import { useCallback, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';

const initialSpeedUpValue = 1;

function useVideoSpeedUp() {
  const [isVideoSpeedUpOpened, setIsVideoSpeedUpOpened] = useState(false);
  const [speedUpValue, setSpeedUpValue] = useState(initialSpeedUpValue);

  const toggleVideoSpeedUpOpened = useCallback(() => {
    setIsVideoSpeedUpOpened(prevState => !prevState);
  }, []);

  const changeSpeedUpValue = useCallback(value => {
    setSpeedUpValue(Number(value));
  }, []);

  const resetVideoSpeedUpContext = useCallback(() => {
    setIsVideoSpeedUpOpened(false);
  }, []);

  return useMemo(
    () => ({
      isVideoSpeedUpOpened,
      speedUpValue,
      toggleVideoSpeedUpOpened,
      changeSpeedUpValue,
      resetVideoSpeedUpContext,
    }),
    [isVideoSpeedUpOpened, speedUpValue, toggleVideoSpeedUpOpened, changeSpeedUpValue, resetVideoSpeedUpContext]
  );
}

export const useVideoSpeedUpContext = constate(useVideoSpeedUp);

const VideoSpeedUpContext = {
  Provider: useVideoSpeedUpContext.Provider,
};

export default VideoSpeedUpContext;
